(function () {
  var roots = document.querySelectorAll('[data-hs-garage-account]');
  var STATUS_LABELS = {
    private: 'Prive',
    public: 'Openbaar',
    draft: 'Concept',
    pending_review: 'In beoordeling',
    published: 'Gepubliceerd',
    rejected: 'Afgewezen',
    mounted: 'Gemonteerd',
    planned: 'Gepland',
    wishlist: 'Wishlist',
  };
  var MAX_PHOTOS_PER_VEHICLE = 15;
  var IMAGE_UPLOAD_MAX_BYTES = 2 * 1024 * 1024;
  var IMAGE_UPLOAD_MAX_EDGE = 1920;
  var IMAGE_UPLOAD_MIN_EDGE = 1280;
  var IMAGE_UPLOAD_QUALITY = 0.84;
  var IMAGE_UPLOAD_MIN_QUALITY = 0.62;
  var OPTIMIZED_IMAGE_TYPE = 'image/jpeg';

  roots.forEach(function (root) {
    var backendEnabled = root.dataset.backendEnabled === 'true';
    var appUrl = root.dataset.appUrl || '/apps/garage/account';
    var state = {
      vehicles: [],
      favoriteBuilds: [],
      selectedId: '',
      photoOrderSaving: false,
      photoOrderDirty: false,
      photoOrderSaveTimer: null,
      photoOrderSaveVehicleId: '',
    };

    var message = root.querySelector('[data-garage-account-message]');
    var vehicleFormPanel = root.querySelector('[data-garage-vehicle-form-panel]');
    var vehicleForm = root.querySelector('[data-garage-vehicle-form]');
    var photoForm = root.querySelector('[data-garage-photo-form]');
    var modForm = root.querySelector('[data-garage-mod-form]');
    var profileImageForm = root.querySelector('[data-garage-profile-image-form]');
    var photoInput = root.querySelector('[data-garage-photo-input]');
    var profileImageInput = root.querySelector('[data-garage-profile-image-input]');
    var profileImagePreview = root.querySelector('[data-garage-profile-image-preview]');
    var profileImageFallback = root.querySelector('[data-garage-profile-image-fallback]');
    var profileImageLightbox = root.querySelector('[data-garage-profile-image-lightbox]');
    var photoPreview = root.querySelector('[data-garage-photo-preview]');
    var productList = root.querySelector('[data-garage-product-list]');
    var productSearchInput = root.querySelector('[data-garage-product-search-input]');
    var productSearchResults = root.querySelector('[data-garage-product-search-results]');
    var selectedProductIdInput = root.querySelector('[data-garage-selected-product-id]');
    var selectedProductSummary = root.querySelector('[data-garage-selected-product]');
    var notificationList = root.querySelector('[data-garage-notifications]');
    var vehicleIdInput = root.querySelector('[data-garage-vehicle-id]');
    var vehicleTitle = root.querySelector('[data-garage-current-vehicle]');
    var vehicleList = root.querySelector('[data-garage-vehicle-list]');
    var vehicleCount = root.querySelector('[data-garage-vehicle-count]');
    var favoriteBuildList = root.querySelector('[data-garage-favorite-build-list]');
    var favoriteBuildCount = root.querySelector('[data-garage-favorite-build-count]');
    var formTitle = root.querySelector('[data-garage-form-title]');
    var photoList = root.querySelector('[data-garage-photo-list]');
    var modList = root.querySelector('[data-garage-mod-list]');
    var publishButton = root.querySelector('[data-garage-publish]');
    var privateButton = root.querySelector('[data-garage-private]');
    var deleteButton = root.querySelector('[data-garage-delete]');
    var newVehicleButton = root.querySelector('[data-garage-new-vehicle]');
    var brandSelect = root.querySelector('[data-garage-brand]');
    var modelSelect = root.querySelector('[data-garage-model]');
    var accountTabs = Array.prototype.slice.call(root.querySelectorAll('[data-garage-account-tab]'));
    var accountTabPanels = Array.prototype.slice.call(root.querySelectorAll('[data-garage-tab-panel]'));
    var productSearchTimer = null;
    var productSearchRequest = 0;

    bindEvents();
    updateModelOptions();
    switchAccountTab('vehicles');

    if (backendEnabled) {
      loadGarage();
      loadNotifications();
      loadPurchasedProducts();
      window.addEventListener('hs-garage:notifications-updated', loadNotifications);
    }

    function bindEvents() {
      if (newVehicleButton) {
        newVehicleButton.addEventListener('click', function () {
          switchAccountTab('vehicles');
          resetVehicleForm();
          showMessage('Nieuwe auto: vul je gegevens in en sla op. Deze garage blijft standaard prive.', 'info');
          scrollToVehicleForm();
        });
      }

      accountTabs.forEach(function (button) {
        button.addEventListener('click', function () {
          switchAccountTab(button.dataset.garageAccountTab);
        });
      });

      if (vehicleList) {
        vehicleList.addEventListener('click', function (event) {
          var button = event.target.closest('[data-garage-select-vehicle]');
          if (!button) return;
          selectVehicle(button.dataset.garageSelectVehicle, { scrollToForm: true });
        });
      }

      if (vehicleForm) {
        vehicleForm.addEventListener('submit', async function (event) {
          if (!backendEnabled) return;
          event.preventDefault();
          setLoading(vehicleForm, true);

          try {
            var payload = await submitForm(vehicleForm);
            var savedId = payload.vehicle && payload.vehicle.id;
            await loadGarage(savedId);
            showMessage('Je garage is opgeslagen.', 'success', { scroll: true });
          } catch (error) {
            showMessage(error.message, 'error', { scroll: true });
          } finally {
            setLoading(vehicleForm, false);
          }
        });
      }

      if (publishButton) {
        publishButton.addEventListener('click', async function () {
          var vehicle = selectedVehicle();
          if (!vehicle) return;

          var confirmed = window.confirm(
            'Je zet jouw garage nu online. Iedereen kan deze garage bekijken in H&S Garage. Je klantaccount en e-mail worden niet openbaar getoond. Doorgaan?'
          );

          if (!confirmed) return;
          await statusAction(vehicle.id, 'publish', 'Je garage staat online.');
        });
      }

      if (privateButton) {
        privateButton.addEventListener('click', async function () {
          var vehicle = selectedVehicle();
          if (!vehicle) return;
          await statusAction(vehicle.id, 'private', 'Je garage is prive gezet.');
        });
      }

      if (deleteButton) {
        deleteButton.addEventListener('click', async function () {
          var vehicle = selectedVehicle();
          if (!vehicle) return;

          var confirmed = window.confirm(
            "Weet je zeker dat je \"" + vehicleTitleText(vehicle) + "\" uit je garage wilt verwijderen? Foto's en gekoppelde onderdelen bij deze auto worden ook verwijderd."
          );

          if (!confirmed) return;
          await deleteSelectedVehicle(vehicle);
        });
      }

      if (notificationList) {
        notificationList.addEventListener('click', function (event) {
          var dismissButton = event.target.closest('[data-garage-dismiss-notification]');
          if (!dismissButton) return;

          dismissNotification(dismissButton.dataset.garageDismissNotification);
          var item = dismissButton.closest('[data-garage-notification-id]');
          if (item) item.remove();
          if (!notificationList.querySelector('[data-garage-notification-id]')) {
            notificationList.hidden = true;
          }
        });
      }

      if (brandSelect && modelSelect) {
        brandSelect.addEventListener('change', updateModelOptions);
      }

      if (photoInput && photoPreview) {
        photoInput.addEventListener('change', previewSelectedPhotos);
      }

      if (profileImageInput) {
        profileImageInput.addEventListener('change', previewSelectedProfileImage);
      }

      if (profileImageLightbox) {
        profileImageLightbox.addEventListener('click', function () {
          var src = profileImagePreview && profileImagePreview.src;
          if (!src) return;
          openLightbox(src, 'Profielfoto eigenaar');
        });
      }

      if (photoList) {
        photoList.addEventListener('click', function (event) {
          var saveTextButton = event.target.closest('[data-garage-save-photo-text]');
          if (saveTextButton) {
            savePhotoText(saveTextButton.dataset.garageSavePhotoText, saveTextButton);
            return;
          }

          var deleteButton = event.target.closest('[data-garage-delete-photo]');
          if (deleteButton) {
            deletePhoto(deleteButton.dataset.garageDeletePhoto);
            return;
          }

          var moveButton = event.target.closest('[data-garage-move-photo]');
          if (moveButton) {
            movePhoto(moveButton.dataset.garageMovePhoto, moveButton.dataset.garageMoveDirection);
            return;
          }

          var trigger = event.target.closest('[data-garage-lightbox-src]');
          if (!trigger) return;
          openLightbox(trigger.dataset.garageLightboxSrc, trigger.dataset.garageLightboxAlt || '');
        });
      }

      if (modList) {
        modList.addEventListener('click', function (event) {
          var deleteButton = event.target.closest('[data-garage-delete-mod]');
          if (!deleteButton) return;
          deleteModification(deleteButton.dataset.garageDeleteMod);
        });
      }

      if (favoriteBuildList) {
        favoriteBuildList.addEventListener('click', function (event) {
          var removeButton = event.target.closest('[data-garage-remove-favorite]');
          if (!removeButton) return;

          removeFavoriteBuild(removeButton.dataset.garageRemoveFavorite, removeButton);
        });
      }

      if (productSearchInput) {
        productSearchInput.addEventListener('input', function () {
          window.clearTimeout(productSearchTimer);

          productSearchTimer = window.setTimeout(function () {
            searchProducts(productSearchInput.value);
          }, 260);
        });
      }

      if (productSearchResults) {
        productSearchResults.addEventListener('click', function (event) {
          var button = event.target.closest('[data-garage-search-product-id]');
          if (!button) return;

          selectProductForMod({
            productId: button.dataset.garageSearchProductId,
            title: button.dataset.garageSearchProductTitle,
            vendor: button.dataset.garageSearchProductVendor,
            image: button.dataset.garageSearchProductImage,
            imageAlt: button.dataset.garageSearchProductImageAlt,
            url: button.dataset.garageSearchProductUrl,
          });
        });
      }

      if (selectedProductSummary) {
        selectedProductSummary.addEventListener('click', function (event) {
          if (!event.target.closest('[data-garage-clear-selected-product]')) return;
          clearSelectedProduct();
        });
      }

      if (photoForm) {
        photoForm.addEventListener('submit', async function (event) {
          if (!backendEnabled) return;
          event.preventDefault();

          var vehicle = selectedVehicle();
          if (!vehicle) {
            showMessage('Sla eerst je auto op voordat je foto\'s uploadt.', 'error');
            return;
          }

          if (!canAddSelectedPhotos(vehicle)) {
            return;
          }

          setLoading(photoForm, true);

          try {
            var action = photoForm.dataset.actionTemplate.replace('__VEHICLE_ID__', encodeURIComponent(vehicle.id));
            showMessage('Foto\'s worden geoptimaliseerd voor snelle weergave.', 'info');
            var photoFormData = await formDataWithOptimizedImages(photoForm);
            await submitForm(photoForm, action, { formData: photoFormData });
            var visibilityField = photoForm.querySelector('[name="visibility"]');
            var isPublicPhoto = visibilityField && visibilityField.value === 'public';
            photoForm.reset();
            clearPreview();
            await loadGarage(vehicle.id);
            showMessage(
              isPublicPhoto ? 'Foto opgeslagen. Als je garage online staat, is deze foto direct zichtbaar.' : 'Foto opgeslagen in je prive garage.',
              'success'
            );
          } catch (error) {
            showMessage(error.message, 'error');
          } finally {
            setLoading(photoForm, false);
          }
        });
      }

      if (profileImageForm) {
        profileImageForm.addEventListener('submit', async function (event) {
          if (!backendEnabled) return;
          event.preventDefault();

          var vehicle = selectedVehicle();
          if (!vehicle) {
            showMessage('Sla eerst je auto op voordat je een profielfoto uploadt.', 'error');
            return;
          }

          var files = Array.prototype.slice.call((profileImageInput && profileImageInput.files) || []);
          if (!files.length) {
            showMessage('Kies eerst een profielfoto.', 'error');
            return;
          }

          setLoading(profileImageForm, true);

          try {
            var action = profileImageForm.dataset.actionTemplate.replace('__VEHICLE_ID__', encodeURIComponent(vehicle.id));
            var profileFormData = await formDataWithOptimizedImages(profileImageForm);
            await submitForm(profileImageForm, action, { formData: profileFormData });
            profileImageForm.reset();
            await loadGarage(vehicle.id);
            showMessage('Profielfoto succesvol opgeslagen. Je profielfoto staat nu bij je online garage.', 'success', { scroll: true });
          } catch (error) {
            showMessage(error.message, 'error', { scroll: true });
          } finally {
            setLoading(profileImageForm, false);
          }
        });
      }

      if (modForm) {
        modForm.addEventListener('submit', async function (event) {
          if (!backendEnabled) return;
          event.preventDefault();

          var vehicle = selectedVehicle();
          if (!vehicle) {
            showMessage('Sla eerst je auto op voordat je onderdelen toevoegt.', 'error');
            return;
          }

          setLoading(modForm, true);

          try {
            var action = modForm.dataset.actionTemplate.replace('__VEHICLE_ID__', encodeURIComponent(vehicle.id));
            var modFormData = await formDataWithOptimizedImages(modForm);
            await submitForm(modForm, action, { formData: modFormData });
            modForm.reset();
            clearSelectedProduct();
            await loadGarage(vehicle.id);
            showMessage('Onderdeel opgeslagen bij je build.', 'success');
          } catch (error) {
            showMessage(error.message, 'error');
          } finally {
            setLoading(modForm, false);
          }
        });
      }

      if (productList) {
        productList.addEventListener('click', async function (event) {
          var button = event.target.closest('[data-garage-link-product]');
          if (!button || !backendEnabled) return;

          var productCard = button.closest('[data-garage-product-id]');
          var vehicle = selectedVehicle();

          if (!vehicle) {
            showMessage('Selecteer of sla eerst een auto op voordat je producten koppelt.', 'error');
            return;
          }

          var formData = new FormData();
          formData.append('product_id', productCard.dataset.garageProductId);
          formData.append('title', productCard.dataset.garageProductTitle || productCard.querySelector('h3').textContent.trim());
          formData.append('brand', 'H&S Corse');
          formData.append('category', 'Overig');
          formData.append('status', 'mounted');

          button.disabled = true;

          try {
            var response = await fetch(appUrl + '/vehicles/' + encodeURIComponent(vehicle.id) + '/mods', {
              method: 'POST',
              body: formData,
              credentials: 'same-origin',
              headers: { Accept: 'application/json' },
            });
            var payload = await readJson(response);

            if (!response.ok || payload.ok === false) {
              throw new Error(payload.error || 'Product koppelen is mislukt.');
            }

            await loadGarage(vehicle.id);
            showMessage('Product gekoppeld aan je garage.', 'success');
            button.textContent = 'Gekoppeld';
            button.classList.add('is-disabled');
          } catch (error) {
            showMessage(error.message, 'error');
            button.disabled = false;
          }
        });
      }
    }

    async function loadGarage(preferredVehicleId, attempt) {
      if (!vehicleList) return;
      attempt = attempt || 0;

      vehicleList.innerHTML = '<div class="hs-garage__empty">Je garage wordt geladen.</div>';

      try {
        var response = await fetch(appUrl + '/garage-data', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        if ((response.status === 503 || response.status === 502 || response.status === 504) && attempt < 2) {
          window.setTimeout(function () {
            loadGarage(preferredVehicleId, attempt + 1);
          }, 900 + attempt * 900);
          return;
        }

        var payload = await readJson(response);

        if (!response.ok) {
          throw new Error(payload.error || 'Garage kon niet worden opgehaald.');
        }

        state.vehicles = payload.vehicles || [];
        state.favoriteBuilds = payload.favoriteBuilds || [];
        renderVehicleList();
        renderFavoriteBuilds();

        if (preferredVehicleId) {
          selectVehicle(preferredVehicleId);
        } else if (state.selectedId && findVehicle(state.selectedId)) {
          selectVehicle(state.selectedId);
        } else if (state.vehicles.length > 0) {
          selectVehicle(state.vehicles[0].id);
        } else {
          resetVehicleForm();
        }
      } catch (error) {
        if (attempt < 2 && /serverreactie|opgestart|wakker|tijdelijk/i.test(error.message || '')) {
          window.setTimeout(function () {
            loadGarage(preferredVehicleId, attempt + 1);
          }, 900 + attempt * 900);
          return;
        }

        vehicleList.innerHTML = '<div class="hs-garage__empty">Garage kon nu niet worden geladen. Vernieuw de pagina over een paar seconden.</div>';
        if (favoriteBuildList) {
          favoriteBuildList.innerHTML = '<div class="hs-garage__empty">Favoriete builds konden nu niet worden geladen.</div>';
        }
        showMessage(error.message || 'Garage kon nu niet worden geladen.', 'error');
      }
    }

    function renderVehicleList() {
      if (vehicleCount) {
        vehicleCount.textContent = state.vehicles.length + (state.vehicles.length === 1 ? ' auto' : ' auto\'s');
      }

      if (!state.vehicles.length) {
        vehicleList.innerHTML = '<div class="hs-garage__empty">Je hebt nog geen auto toegevoegd.</div>';
        return;
      }

      vehicleList.innerHTML = state.vehicles.map(vehicleCardTemplate).join('');
    }

    function vehicleCardTemplate(vehicle) {
      var title = vehicleTitleText(vehicle);
      var image = vehicle.mainImage || '';
      var status = statusText(vehicle);
      var statusClass = statusClassName(vehicle);
      var buildScore = buildCompleteness(vehicle);
      var active = vehicle.id === state.selectedId ? ' is-active' : '';
      var onlineUrl = vehicleOnlineUrl(vehicle);

      return [
        '<article class="hs-garage-vehicle-card' + active + '">',
        '<button class="hs-garage-vehicle-card__media" type="button" data-garage-select-vehicle="' + escapeHtml(vehicle.id) + '" aria-label="Bewerk ' + escapeHtml(title) + '">',
        image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(vehicle.mainImageAlt || title) + '" loading="lazy">' : '<div class="hs-garage-vehicle-card__fallback"></div>',
        '</button>',
        '<div class="hs-garage-vehicle-card__body">',
        '<h3>' + escapeHtml(title) + '</h3>',
        '<p>' + escapeHtml([vehicle.year, vehicle.stage, vehicle.powerHp ? vehicle.powerHp + ' PK' : ''].filter(Boolean).join(' · ')) + '</p>',
        '<span class="hs-garage-chip ' + statusClass + '">' + escapeHtml(status) + '</span>',
        buildScoreTemplate(buildScore),
        onlineUrl ? '<span class="hs-garage-vehicle-card__comment-count">Reacties ' + Number(vehicle.commentCount || 0) + '</span>' : '',
        '<div class="hs-garage-vehicle-card__actions">',
        onlineUrl ? '<a class="hs-garage__button hs-garage__button--ghost hs-garage-vehicle-card__online" href="' + escapeHtml(onlineUrl) + '">Bekijk mijn online garage</a>' : '',
        '<button class="hs-garage__button hs-garage__button--ghost" type="button" data-garage-select-vehicle="' + escapeHtml(vehicle.id) + '">Bewerken</button>',
        '</div>',
        '</div>',
        '</article>',
      ].join('');
    }

    function buildScoreTemplate(score) {
      return [
        '<div class="hs-garage-build-score" aria-label="Build-score ' + score.percent + ' procent">',
        '<div class="hs-garage-build-score__head">',
        '<strong>Build-score</strong>',
        '<span>' + score.percent + '%</span>',
        '</div>',
        '<div class="hs-garage-build-score__bar" aria-hidden="true"><span style="width: ' + score.percent + '%;"></span></div>',
        '<p>' + escapeHtml(score.hint) + '</p>',
        '</div>',
      ].join('');
    }

    function vehicleOnlineUrl(vehicle) {
      if (!vehicle || vehicle.privacyStatus !== 'public' || vehicle.moderationStatus !== 'published') return '';
      var slug = vehicle.slug || vehicle.handle || '';
      return slug ? '/apps/garage/public/builds/' + encodeURIComponent(slug) : '';
    }

    function switchAccountTab(tabName) {
      var selectedTab = tabName || 'vehicles';

      accountTabs.forEach(function (button) {
        var active = button.dataset.garageAccountTab === selectedTab;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      accountTabPanels.forEach(function (panel) {
        panel.hidden = panel.dataset.garageTabPanel !== selectedTab;
      });
    }

    function renderFavoriteBuilds() {
      if (!favoriteBuildList) return;

      var builds = state.favoriteBuilds || [];
      if (favoriteBuildCount) {
        favoriteBuildCount.textContent = builds.length + (builds.length === 1 ? ' favoriet' : ' favorieten');
      }

      if (!builds.length) {
        favoriteBuildList.innerHTML = '<div class="hs-garage__empty">Je hebt nog geen favoriete garage\'s opgeslagen.</div>';
        return;
      }

      favoriteBuildList.innerHTML = builds.map(favoriteBuildTemplate).join('');
    }

    function favoriteBuildTemplate(build) {
      var title = build.title || [build.brand, build.model, build.variant].filter(Boolean).join(' ') || 'H&S Garage build';
      var image = build.mainImage || '';
      var slug = build.slug || build.handle || '';
      var url = build.url || (slug ? '/apps/garage/public/builds/' + encodeURIComponent(slug) : '/pages/hs-garage');
      var meta = [build.year, build.stage, build.powerHp ? build.powerHp + ' PK' : ''].filter(Boolean).join(' · ');

      return [
        '<article class="hs-garage-favorite-build-card">',
        '<a class="hs-garage-favorite-build-card__media" href="' + escapeHtml(url) + '">',
        image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(build.mainImageAlt || title) + '" loading="lazy">' : '<div class="hs-garage-card__fallback"></div>',
        '</a>',
        '<div class="hs-garage-favorite-build-card__body">',
        '<h3>' + escapeHtml(title) + '</h3>',
        meta ? '<p>' + escapeHtml(meta) + '</p>' : '',
        '<div class="hs-garage-favorite-build-card__stats">',
        '<span>' + Number(build.modificationCount || 0) + ' onderdelen</span>',
        '<span>' + Number(build.viewCount || 0) + ' weergaven</span>',
        '<span>' + Number(build.favoriteCount || 0) + ' favorieten</span>',
        '<span>' + Number(build.commentCount || 0) + (Number(build.commentCount || 0) === 1 ? ' reactie' : ' reacties') + '</span>',
        '</div>',
        '<div class="hs-garage-favorite-build-card__actions">',
        '<a class="hs-garage__button" href="' + escapeHtml(url) + '">Bekijk build</a>',
        slug ? '<button class="hs-garage__button hs-garage__button--ghost" type="button" data-garage-remove-favorite="' + escapeHtml(slug) + '">Verwijder favoriet</button>' : '',
        '</div>',
        '</div>',
        '</article>',
      ].join('');
    }

    async function removeFavoriteBuild(slug, button) {
      if (!slug) return;

      if (button) button.disabled = true;

      try {
        var response = await fetch('/apps/garage/public/builds/' + encodeURIComponent(slug) + '/favorite', {
          method: 'POST',
          body: new FormData(),
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        var payload = await readJson(response);

        if (!response.ok || payload.ok === false) {
          throw new Error(payload.error || 'Favoriet verwijderen is mislukt.');
        }

        state.favoriteBuilds = state.favoriteBuilds.filter(function (build) {
          return (build.slug || build.handle) !== slug;
        });
        renderFavoriteBuilds();
        showMessage('Build verwijderd uit je favorieten.', 'success', { scroll: true });
      } catch (error) {
        showMessage(error.message, 'error', { scroll: true });
      } finally {
        if (button) button.disabled = false;
      }
    }

    function selectVehicle(id, options) {
      var vehicle = findVehicle(id);
      if (!vehicle) return;

      state.selectedId = vehicle.id;
      if (vehicleIdInput) vehicleIdInput.value = vehicle.id;
      if (formTitle) formTitle.textContent = 'Auto bewerken';
      if (vehicleTitle) vehicleTitle.textContent = vehicleTitleText(vehicle);

      setVehicleFormValues(vehicle);
      renderVehicleList();
      renderPhotos(vehicle);
      renderMods(vehicle);
      renderProfileImage(vehicle);
      updateActionButtons(vehicle);
      root.classList.add('has-saved-vehicle');

      if (options && options.scrollToForm) {
        scrollToVehicleForm();
      }
    }

    function resetVehicleForm() {
      state.selectedId = '';
      if (vehicleForm) vehicleForm.reset();
      if (vehicleIdInput) vehicleIdInput.value = '';
      if (formTitle) formTitle.textContent = 'Auto toevoegen';
      if (vehicleTitle) vehicleTitle.textContent = 'nog niet opgeslagen';
      renderVehicleList();
      renderPhotos(null);
      renderMods(null);
      renderProfileImage(null);
      updateActionButtons(null);
      updateModelOptions();
    }

    function setVehicleFormValues(vehicle) {
      setField('owner_display_name', vehicle.ownerDisplayName);
      setField('brand', vehicle.brand);
      updateModelOptions();
      setField('model', vehicle.model);
      setField('variant', vehicle.variant);
      setField('year', vehicle.year);
      setField('engine', vehicle.engine);
      setField('stage', vehicle.stage);
      setField('power_hp', vehicle.powerHp);
      setField('torque_nm', vehicle.torqueNm);
      setField('color', vehicle.color);
      setField('country', vehicle.country);
      setField('instagram_url', vehicle.instagramUrl);
      setField('facebook_url', vehicle.facebookUrl);
      setField('tiktok_url', vehicle.tiktokUrl);
      setField('description', vehicle.description);
    }

    function setField(name, value) {
      if (!vehicleForm) return;
      var field = vehicleForm.querySelector('[name="' + name + '"]');
      if (!field) return;

      if (field.tagName === 'SELECT') {
        setSelectValue(field, value);
      } else {
        field.value = value || '';
      }
    }

    function setSelectValue(select, value) {
      var stringValue = String(value || '');
      if (!stringValue) {
        select.value = '';
        return;
      }

      var exists = Array.prototype.slice.call(select.options).some(function (option) {
        return option.value === stringValue;
      });

      if (!exists) {
        var option = document.createElement('option');
        option.value = stringValue;
        option.textContent = stringValue;
        if (select === modelSelect && brandSelect) option.dataset.brand = brandSelect.value;
        select.appendChild(option);
      }

      select.value = stringValue;
    }

    function renderPhotos(vehicle) {
      if (!photoList) return;

      var photos = vehicle ? vehicle.photos || [] : [];
      if (!photos.length) {
        photoList.classList.remove('hs-garage-album');
        photoList.innerHTML = '<div class="hs-garage__empty">Nog geen foto\'s bij deze auto.</div>';
        return;
      }

      photoList.classList.add('hs-garage-album');
      photoList.innerHTML = photos.map(function (photo, index) {
        var image = photo.references && photo.references.image;
        var status = photo.visibility === 'public' ? label(photo.moderationStatus) : 'Prive';
        var title = photo.title || 'Garage foto';
        var description = photo.description || '';
        var editor = photoEditorTemplate(photo, title, description);
        var orderControls = photoOrderControlsTemplate(photo, index, photos.length);
        var mainBadge = index === 0 ? '<span class="hs-garage-photo-main-badge">Hoofdfoto</span>' : '';
        var articleClass = index === 0 ? ' is-main-photo' : '';

        if (!image || !image.imageUrl) {
          return [
            '<article class="hs-garage-mini-card hs-garage-mini-card--manageable' + articleClass + '">',
            '<div>',
            '<h3>' + escapeHtml(title) + '</h3>',
            '<div class="hs-garage-photo-meta"><small>' + escapeHtml(status) + '</small>' + mainBadge + '</div>',
            orderControls,
            editor,
            '<button class="hs-garage-mini-delete" type="button" data-garage-delete-photo="' + escapeHtml(photo.id) + '">Verwijderen</button>',
            '</div>',
            '</article>',
          ].join('');
        }

        return [
          '<article class="hs-garage-album-card' + articleClass + '">',
          '<button class="hs-garage-album-item" type="button" data-garage-lightbox-src="' + escapeHtml(image.imageUrl) + '" data-garage-lightbox-alt="' + escapeHtml(image.imageAlt || title) + '">',
          '<img src="' + escapeHtml(image.imageUrl) + '" alt="' + escapeHtml(image.imageAlt || title) + '" loading="lazy">',
          '</button>',
          '<div class="hs-garage-album-card__body">',
          '<strong>' + escapeHtml(title) + '</strong>',
          '<div class="hs-garage-photo-meta"><small>' + escapeHtml(status) + '</small>' + mainBadge + '</div>',
          description ? '<p>' + escapeHtml(description) + '</p>' : '',
          orderControls,
          editor,
          '<button class="hs-garage-mini-delete" type="button" data-garage-delete-photo="' + escapeHtml(photo.id) + '">Verwijderen</button>',
          '</div>',
          '</article>',
        ].join('');
      }).join('');
    }

    function photoOrderControlsTemplate(photo, index, total) {
      var disabledUp = index === 0 ? ' disabled' : '';
      var disabledDown = index >= total - 1 ? ' disabled' : '';

      return [
        '<div class="hs-garage-photo-order" aria-label="Fotovolgorde">',
        '<span>Positie ' + (index + 1) + '</span>',
        '<button type="button" data-garage-move-photo="' + escapeHtml(photo.id) + '" data-garage-move-direction="up"' + disabledUp + '>Omhoog</button>',
        '<button type="button" data-garage-move-photo="' + escapeHtml(photo.id) + '" data-garage-move-direction="down"' + disabledDown + '>Omlaag</button>',
        '</div>',
      ].join('');
    }

    function photoEditorTemplate(photo, title, description) {
      return [
        '<details class="hs-garage-photo-edit" data-garage-photo-editor="' + escapeHtml(photo.id) + '">',
        '<summary>Tekst bewerken</summary>',
        '<label>Titel',
        '<input type="text" value="' + escapeHtml(title) + '" data-garage-photo-title>',
        '</label>',
        '<label>Omschrijving',
        '<textarea data-garage-photo-description>' + escapeHtml(description) + '</textarea>',
        '</label>',
        '<button class="hs-garage-mini-save" type="button" data-garage-save-photo-text="' + escapeHtml(photo.id) + '">Tekst opslaan</button>',
        '</details>',
      ].join('');
    }

    function renderMods(vehicle) {
      if (!modList) return;

      var modifications = vehicle ? vehicle.modifications || [] : [];
      if (!modifications.length) {
        modList.innerHTML = '<div class="hs-garage__empty">Nog geen onderdelen bij deze auto.</div>';
        return;
      }

      modList.innerHTML = modifications.map(function (modification) {
        var product = modification.references && modification.references.linkedProduct;
        var image = (modification.references && modification.references.image) || product;
        var imageUrl = image && image.imageUrl ? image.imageUrl : modification.externalImageUrl;
        var imageAlt = image && image.imageAlt ? image.imageAlt : modification.externalImageAlt;
        var externalUrl = safeLinkUrl(modification.externalUrl);
        var linkUrl = product && product.url ? product.url : externalUrl;
        var linkText = product && product.url ? 'Bekijk product' : 'Bekijk link';
        return [
          '<article class="hs-garage-mini-card hs-garage-mini-card--manageable">',
          imageUrl ? '<img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(imageAlt || modification.title) + '" loading="lazy">' : '',
          '<div>',
          '<h3>' + escapeHtml(modification.title || 'Onderdeel') + '</h3>',
          '<p>' + escapeHtml([modification.category, label(modification.status)].filter(Boolean).join(' · ')) + '</p>',
          linkUrl ? '<a href="' + escapeHtml(linkUrl) + '"' + (/^https?:\/\//i.test(linkUrl) ? ' target="_blank" rel="noopener"' : '') + '>' + escapeHtml(linkText) + '</a>' : '',
          '<button class="hs-garage-mini-delete" type="button" data-garage-delete-mod="' + escapeHtml(modification.id) + '">Verwijderen</button>',
          '</div>',
          '</article>',
        ].join('');
      }).join('');
    }

    function renderProfileImage(vehicle) {
      var image = vehicle && vehicle.ownerProfileImage ? vehicle.ownerProfileImage : '';
      var alt = vehicle && vehicle.ownerProfileImageAlt ? vehicle.ownerProfileImageAlt : 'Profielfoto eigenaar';

      if (profileImagePreview) {
        if (image) {
          profileImagePreview.src = image;
          profileImagePreview.alt = alt;
          profileImagePreview.hidden = false;
        } else {
          profileImagePreview.removeAttribute('src');
          profileImagePreview.hidden = true;
        }
      }

      if (profileImageFallback) {
        profileImageFallback.hidden = Boolean(image);
      }

      if (profileImageLightbox) {
        profileImageLightbox.disabled = !image;
      }
    }

    function updateActionButtons(vehicle) {
      var requiresVehicle = root.querySelectorAll('[data-garage-requires-vehicle]');
      Array.prototype.slice.call(requiresVehicle).forEach(function (button) {
        button.disabled = !vehicle;
      });

      if (publishButton) {
        var isOnline = vehicle && vehicle.privacyStatus === 'public' && vehicle.moderationStatus === 'published';
        publishButton.disabled = !vehicle || isOnline;
      }

      if (privateButton) {
        privateButton.disabled = !vehicle || vehicle.privacyStatus === 'private';
      }

      if (deleteButton) {
        deleteButton.disabled = !vehicle;
      }
    }

    async function statusAction(vehicleId, action, fallbackMessage) {
      try {
        var formData = new FormData();
        var response = await fetch(appUrl + '/vehicles/' + encodeURIComponent(vehicleId) + '/' + action, {
          method: 'POST',
          body: formData,
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        var payload = await readJson(response);

        if (!response.ok || payload.ok === false) {
          throw new Error(payload.error || 'Status aanpassen is mislukt.');
        }

        await loadGarage(vehicleId);
        showMessage(payload.message || fallbackMessage, 'success', { scroll: true });
      } catch (error) {
        showMessage(error.message, 'error', { scroll: true });
      }
    }

    async function deleteSelectedVehicle(vehicle) {
      var formData = new FormData();

      if (deleteButton) deleteButton.disabled = true;

      try {
        var response = await fetch(appUrl + '/vehicles/' + encodeURIComponent(vehicle.id) + '/delete', {
          method: 'POST',
          body: formData,
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        var payload = await readJson(response);

        if (!response.ok || payload.ok === false) {
          throw new Error(payload.error || 'Auto verwijderen is mislukt.');
        }

        state.selectedId = '';
        await loadGarage();
        showMessage(payload.message || 'Auto verwijderd uit je garage.', 'success');
      } catch (error) {
        showMessage(error.message, 'error');
      } finally {
        updateActionButtons(selectedVehicle());
      }
    }

    async function deletePhoto(photoId) {
      var vehicle = selectedVehicle();
      if (!vehicle || !photoId) return;

      var confirmed = window.confirm('Weet je zeker dat je deze foto uit je garage wilt verwijderen?');
      if (!confirmed) return;

      await deleteGarageItem({
        url: appUrl + '/vehicles/' + encodeURIComponent(vehicle.id) + '/photos/' + encodeURIComponent(photoId) + '/delete',
        reloadVehicleId: vehicle.id,
        fallbackMessage: 'Foto verwijderd uit je garage.',
      });
    }

    function movePhoto(photoId, direction) {
      var vehicle = selectedVehicle();
      if (!vehicle || !photoId) return;

      var photos = (vehicle.photos || []).slice();
      var currentIndex = photos.findIndex(function (photo) {
        return photo.id === photoId;
      });
      var targetIndex = direction === 'up' ? currentIndex - 1 : currentIndex + 1;

      if (currentIndex < 0 || targetIndex < 0 || targetIndex >= photos.length) return;

      var movedPhoto = photos.splice(currentIndex, 1)[0];
      photos.splice(targetIndex, 0, movedPhoto);
      photos.forEach(function (photo, index) {
        photo.sortOrder = String(index + 1);
      });
      vehicle.photos = photos;
      updateVehicleMainImageFromFirstPhoto(vehicle);
      renderVehicleList();
      renderPhotos(vehicle);
      schedulePhotoOrderSave(vehicle.id);
    }

    function updateVehicleMainImageFromFirstPhoto(vehicle) {
      var firstPhoto = vehicle && vehicle.photos && vehicle.photos[0];
      var image = firstPhoto && firstPhoto.references && firstPhoto.references.image;

      if (!image || !image.imageUrl) return;

      vehicle.mainImage = image.imageUrl;
      vehicle.mainImageAlt = image.imageAlt || firstPhoto.title || vehicleTitleText(vehicle);
    }

    function schedulePhotoOrderSave(vehicleId) {
      state.photoOrderDirty = true;
      state.photoOrderSaveVehicleId = vehicleId;
      window.clearTimeout(state.photoOrderSaveTimer);

      state.photoOrderSaveTimer = window.setTimeout(function () {
        savePhotoOrder();
      }, 420);
    }

    async function savePhotoOrder() {
      if (state.photoOrderSaving) return;

      var vehicleId = state.photoOrderSaveVehicleId;
      var vehicle = findVehicle(vehicleId);
      if (!vehicle || !state.photoOrderDirty) return;

      var orderedPhotoIds = (vehicle.photos || []).map(function (photo) {
        return photo.id;
      });

      state.photoOrderSaving = true;
      state.photoOrderDirty = false;
      if (photoList) photoList.classList.add('is-saving-order');

      try {
        var formData = new FormData();
        formData.append('photo_order', JSON.stringify(orderedPhotoIds));

        var response = await fetch(appUrl + '/vehicles/' + encodeURIComponent(vehicle.id) + '/photos/order', {
          method: 'POST',
          body: formData,
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        var payload = await readJson(response);

        if (!response.ok || payload.ok === false) {
          throw new Error(payload.error || 'Fotovolgorde opslaan is mislukt.');
        }

        showMessage('Fotovolgorde opgeslagen. Positie 1 is nu je hoofd foto.', 'success');
      } catch (error) {
        state.photoOrderSaving = false;
        await loadGarage(vehicleId);
        showMessage(error.message, 'error');
      } finally {
        state.photoOrderSaving = false;
        if (photoList) photoList.classList.remove('is-saving-order');

        if (state.photoOrderDirty) {
          savePhotoOrder();
        }
      }
    }

    async function savePhotoText(photoId, button) {
      var vehicle = selectedVehicle();
      if (!vehicle || !photoId) return;

      var editor = button && button.closest('[data-garage-photo-editor]');
      if (!editor) return;

      var titleField = editor.querySelector('[data-garage-photo-title]');
      var descriptionField = editor.querySelector('[data-garage-photo-description]');
      var formData = new FormData();

      formData.append('title', titleField ? titleField.value : '');
      formData.append('description', descriptionField ? descriptionField.value : '');

      if (button) button.disabled = true;

      try {
        var response = await fetch(appUrl + '/vehicles/' + encodeURIComponent(vehicle.id) + '/photos/' + encodeURIComponent(photoId), {
          method: 'POST',
          body: formData,
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        var payload = await readJson(response);

        if (!response.ok || payload.ok === false) {
          throw new Error(payload.error || 'Fototekst opslaan is mislukt.');
        }

        await loadGarage(vehicle.id);
        showMessage(payload.message || 'Fototekst bijgewerkt.', 'success');
      } catch (error) {
        showMessage(error.message, 'error');
      } finally {
        if (button) button.disabled = false;
      }
    }

    async function deleteModification(modificationId) {
      var vehicle = selectedVehicle();
      if (!vehicle || !modificationId) return;

      var confirmed = window.confirm('Weet je zeker dat je dit onderdeel uit je garage wilt verwijderen?');
      if (!confirmed) return;

      await deleteGarageItem({
        url: appUrl + '/vehicles/' + encodeURIComponent(vehicle.id) + '/mods/' + encodeURIComponent(modificationId) + '/delete',
        reloadVehicleId: vehicle.id,
        fallbackMessage: 'Onderdeel verwijderd uit je garage.',
      });
    }

    async function deleteGarageItem(options) {
      try {
        var response = await fetch(options.url, {
          method: 'POST',
          body: new FormData(),
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        var payload = await readJson(response);

        if (!response.ok || payload.ok === false) {
          throw new Error(payload.error || 'Verwijderen is mislukt.');
        }

        await loadGarage(options.reloadVehicleId);
        showMessage(payload.message || options.fallbackMessage, 'success');
      } catch (error) {
        showMessage(error.message, 'error');
      }
    }

    function previewSelectedPhotos() {
      clearPreview();

      var vehicle = selectedVehicle();
      var files = selectedPhotoFiles();
      var remaining = remainingPhotoSlots(vehicle);

      if (vehicle && files.length > remaining) {
        showMessage('Je kunt maximaal ' + photoLimit() + ' foto\'s per auto uploaden. Deze auto heeft nog ruimte voor ' + Math.max(remaining, 0) + ' foto\'s.', 'error');
      }

      files.slice(0, Math.max(remaining, 0)).forEach(function (file) {
        if (!file.type || file.type.indexOf('image/') !== 0) return;

        var item = document.createElement('figure');
        var image = document.createElement('img');
        var caption = document.createElement('figcaption');

        image.src = URL.createObjectURL(file);
        image.alt = file.name;
        image.onload = function () {
          URL.revokeObjectURL(image.src);
        };
        caption.textContent = file.name;

        item.appendChild(image);
        item.appendChild(caption);
        photoPreview.appendChild(item);
      });
    }

    function previewSelectedProfileImage() {
      var file = profileImageInput && profileImageInput.files && profileImageInput.files[0];
      if (!file || !file.type || file.type.indexOf('image/') !== 0) return;

      var url = URL.createObjectURL(file);
      if (profileImagePreview) {
        profileImagePreview.src = url;
        profileImagePreview.alt = file.name;
        profileImagePreview.hidden = false;
        profileImagePreview.onload = function () {
          URL.revokeObjectURL(url);
        };
      }

      if (profileImageFallback) profileImageFallback.hidden = true;
      if (profileImageLightbox) profileImageLightbox.disabled = false;
    }

    function canAddSelectedPhotos(vehicle) {
      var files = selectedPhotoFiles();
      var remaining = remainingPhotoSlots(vehicle);

      if (files.length > remaining) {
        showMessage('Je kunt maximaal ' + photoLimit() + ' foto\'s per auto uploaden. Verwijder eerst een foto of kies minder bestanden.', 'error');
        return false;
      }

      return true;
    }

    function selectedPhotoFiles() {
      return Array.prototype.slice.call((photoInput && photoInput.files) || []);
    }

    function remainingPhotoSlots(vehicle) {
      var existing = vehicle && vehicle.photos ? vehicle.photos.length : 0;
      return Math.max(photoLimit() - existing, 0);
    }

    function photoLimit() {
      return Number((photoInput && photoInput.dataset.maxPhotos) || MAX_PHOTOS_PER_VEHICLE);
    }

    function clearPreview() {
      if (photoPreview) photoPreview.innerHTML = '';
    }

    function openLightbox(src, alt) {
      if (!src) return;

      var existing = document.querySelector('[data-garage-lightbox]');
      if (existing) existing.remove();

      var overlay = document.createElement('div');
      overlay.className = 'hs-garage-lightbox';
      overlay.setAttribute('data-garage-lightbox', '');
      overlay.innerHTML = [
        '<button class="hs-garage-lightbox__close" type="button" aria-label="Sluiten">Sluiten</button>',
        '<img src="' + escapeHtml(src) + '" alt="' + escapeHtml(alt) + '">',
      ].join('');

      function closeLightbox() {
        overlay.remove();
        document.removeEventListener('keydown', closeLightboxWithEscape);
      }

      overlay.addEventListener('click', function (event) {
        if (event.target === overlay || event.target.closest('.hs-garage-lightbox__close')) {
          closeLightbox();
        }
      });

      function closeLightboxWithEscape(event) {
        if (event.key === 'Escape') closeLightbox();
      }

      document.addEventListener('keydown', closeLightboxWithEscape);
      document.body.appendChild(overlay);
    }

    async function loadPurchasedProducts(attempt) {
      if (!backendEnabled || !productList) return;
      attempt = attempt || 0;

      try {
        var response = await fetch(appUrl + '/purchased-products', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        if ((response.status === 503 || response.status === 502 || response.status === 504) && attempt < 2) {
          window.setTimeout(function () {
            loadPurchasedProducts(attempt + 1);
          }, 900 + attempt * 900);
          return;
        }
        var payload = await readJson(response);

        if (!response.ok) {
          productList.innerHTML = '<div class="hs-garage__empty">Aankopen konden nu niet worden opgehaald.</div>';
          return;
        }

        if (!payload.products || payload.products.length === 0) {
          productList.innerHTML = '<div class="hs-garage__empty">Geen aankopen bij H&S Corse gevonden op dit account.</div>';
          return;
        }

        productList.innerHTML = payload.products.map(productTemplate).join('');
      } catch (error) {
        if (attempt < 2 && /serverreactie|opgestart|wakker|tijdelijk/i.test(error.message || '')) {
          window.setTimeout(function () {
            loadPurchasedProducts(attempt + 1);
          }, 900 + attempt * 900);
          return;
        }
        productList.innerHTML = '<div class="hs-garage__empty">Aankopen konden nu niet worden opgehaald.</div>';
      }
    }

    async function loadNotifications() {
      if (!backendEnabled || !notificationList) return;

      try {
        var response = await fetch(appUrl + '/notifications', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        var payload = await readJson(response);

        if (!response.ok) return;

        var notifications = (payload.notifications || []).filter(function (notification) {
          return !isNotificationDismissed(notification.id);
        });

        if (!notifications.length) {
          notificationList.hidden = true;
          return;
        }

        notificationList.innerHTML = notifications.map(notificationTemplate).join('');
        notificationList.hidden = false;
      } catch (error) {
        notificationList.hidden = true;
      }
    }

    async function searchProducts(query) {
      if (!backendEnabled || !productSearchResults) return;

      var term = String(query || '').trim();
      productSearchRequest += 1;
      var requestId = productSearchRequest;

      if (term.length < 2) {
        productSearchResults.hidden = true;
        productSearchResults.innerHTML = '';
        return;
      }

      productSearchResults.hidden = false;
      productSearchResults.innerHTML = '<div class="hs-garage-product-search__state">Zoeken...</div>';

      try {
        var response = await fetch(appUrl + '/product-search?q=' + encodeURIComponent(term), {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        var payload = await readJson(response);

        if (requestId !== productSearchRequest) return;

        if (!response.ok) {
          throw new Error(payload.error || 'Producten konden niet worden gezocht.');
        }

        renderProductSearchResults(payload.products || []);
      } catch (error) {
        if (requestId !== productSearchRequest) return;
        productSearchResults.innerHTML = '<div class="hs-garage-product-search__state">Producten konden nu niet worden gezocht.</div>';
      }
    }

    function renderProductSearchResults(products) {
      if (!productSearchResults) return;

      if (!products.length) {
        productSearchResults.hidden = false;
        productSearchResults.innerHTML = '<div class="hs-garage-product-search__state">Geen producten gevonden.</div>';
        return;
      }

      productSearchResults.hidden = false;
      productSearchResults.innerHTML = products.map(productSearchTemplate).join('');
    }

    function productSearchTemplate(product) {
      var title = escapeHtml(product.title || 'H&S product');
      var vendor = escapeHtml(product.vendor || 'H&S Corse');
      var image = escapeHtml(product.image || '');
      var imageAlt = escapeHtml(product.imageAlt || product.title || 'H&S product');
      var productId = escapeHtml(product.productId || '');
      var url = escapeHtml(product.url || '');

      return [
        '<button class="hs-garage-product-search-result" type="button"',
        ' data-garage-search-product-id="' + productId + '"',
        ' data-garage-search-product-title="' + title + '"',
        ' data-garage-search-product-vendor="' + vendor + '"',
        ' data-garage-search-product-image="' + image + '"',
        ' data-garage-search-product-image-alt="' + imageAlt + '"',
        ' data-garage-search-product-url="' + url + '">',
        image ? '<img src="' + image + '" alt="' + imageAlt + '" loading="lazy">' : '<span class="hs-garage-product-option__image-fallback"></span>',
        '<span>',
        '<strong>' + title + '</strong>',
        '<small>' + vendor + '</small>',
        '</span>',
        '<em>Kies product</em>',
        '</button>',
      ].join('');
    }

    function selectProductForMod(product) {
      if (!product || !product.productId) return;

      if (selectedProductIdInput) selectedProductIdInput.value = product.productId;

      fillEmptyModField('title', product.title);
      fillEmptyModField('brand', product.vendor || 'H&S Corse');

      if (selectedProductSummary) {
        selectedProductSummary.hidden = false;
        selectedProductSummary.innerHTML = [
          '<div class="hs-garage-product-selected-card">',
          product.image ? '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.imageAlt || product.title) + '" loading="lazy">' : '<span class="hs-garage-product-option__image-fallback"></span>',
          '<span>',
          '<strong>' + escapeHtml(product.title || 'H&S product') + '</strong>',
          '<small>Gekoppeld webshop-product</small>',
          '</span>',
          '<button type="button" data-garage-clear-selected-product>Loskoppelen</button>',
          '</div>',
        ].join('');
      }

      if (productSearchResults) {
        productSearchResults.hidden = true;
        productSearchResults.innerHTML = '';
      }

      if (productSearchInput) productSearchInput.value = product.title || '';

      showMessage('Product geselecteerd. Vul de rest van het onderdeel aan en sla op.', 'success');
    }

    function clearSelectedProduct() {
      if (selectedProductIdInput) selectedProductIdInput.value = '';
      if (selectedProductSummary) {
        selectedProductSummary.hidden = true;
        selectedProductSummary.innerHTML = '';
      }
      if (productSearchInput) productSearchInput.value = '';
      if (productSearchResults) {
        productSearchResults.hidden = true;
        productSearchResults.innerHTML = '';
      }
    }

    function fillEmptyModField(name, value) {
      if (!modForm || !value) return;

      var field = modForm.querySelector('[name="' + name + '"]');
      if (!field || String(field.value || '').trim()) return;

      field.value = value;
    }

    function productTemplate(product) {
      var title = escapeHtml(product.title || 'H&S product');
      var image = escapeHtml(product.image || '');
      var productId = escapeHtml(product.productId || '');

      return [
        '<article class="hs-garage-product-option" data-garage-product-id="' + productId + '" data-garage-product-title="' + title + '">',
        image ? '<img src="' + image + '" alt="' + title + '" loading="lazy">' : '<div class="hs-garage-product-option__image-fallback"></div>',
        '<div>',
        '<h3>' + title + '</h3>',
        '<p>Aankoop bij H&S Corse · klaar om toe te voegen</p>',
        '<span class="hs-garage-verified">Geverifieerd H&S product</span>',
        '</div>',
        '<button class="hs-garage__button" type="button" data-garage-link-product>Koppelen</button>',
        '</article>',
      ].join('');
    }

    function notificationTemplate(notification) {
      var title = escapeHtml(notification.title || 'Garage update');
      var image = escapeHtml(notification.image || '');
      var url = notification.url ? escapeHtml(notification.url) : '';
      var messageHtml = messageWithLink(notification.message || '', url);
      var id = escapeHtml(notification.id || [notification.type, notification.title, notification.message].filter(Boolean).join('-'));

      return [
        '<article class="hs-garage-notification" data-status="' + escapeHtml(notification.status || 'info') + '" data-garage-notification-id="' + id + '">',
        image ? '<img src="' + image + '" alt="" loading="lazy">' : '<span class="hs-garage-notification__icon">' + notificationIcon(notification.type) + '</span>',
        '<div>',
        '<strong>' + title + '</strong>',
        messageHtml ? '<p>' + messageHtml + '</p>' : '',
        '</div>',
        '<button class="hs-garage-notification__close" type="button" aria-label="Melding sluiten" data-garage-dismiss-notification="' + id + '">&times;</button>',
        '</article>',
      ].join('');
    }

    function notificationIcon(type) {
      if (type === 'favorite') return '★';
      if (type === 'comment' || type === 'reply') return '“';
      if (type === 'like') return '♥';
      return 'OK';
    }

    function dismissedNotifications() {
      try {
        return JSON.parse(localStorage.getItem('hsGarageDismissedNotifications') || '[]');
      } catch (error) {
        return [];
      }
    }

    function isNotificationDismissed(id) {
      if (!id) return false;
      return dismissedNotifications().indexOf(String(id)) !== -1;
    }

    function dismissNotification(id) {
      if (!id) return;

      try {
        var dismissed = dismissedNotifications();
        if (dismissed.indexOf(String(id)) === -1) {
          dismissed.push(String(id));
          localStorage.setItem('hsGarageDismissedNotifications', JSON.stringify(dismissed.slice(-80)));
          window.dispatchEvent(new CustomEvent('hs-garage:notifications-updated'));
        }
      } catch (error) {
        // Closing still works even when browser storage is unavailable.
      }
    }

    function messageWithLink(text, url) {
      var safe = escapeHtml(text);
      if (!url) return safe;

      var labelText = 'H&amp;S Garage';
      var link = '<a href="' + url + '">' + labelText + '</a>';
      if (safe.indexOf(labelText) !== -1) {
        return safe.replace(labelText, link);
      }

      return safe + ' <a href="' + url + '">Bekijk</a>';
    }

    async function formDataWithOptimizedImages(form) {
      var formData = new FormData(form);
      var fileInputs = Array.prototype.slice.call(form.querySelectorAll('input[type="file"][name="image"]'));

      if (!fileInputs.length) return formData;

      formData.delete('image');

      for (var inputIndex = 0; inputIndex < fileInputs.length; inputIndex += 1) {
        var input = fileInputs[inputIndex];
        var files = Array.prototype.slice.call(input.files || []);

        for (var fileIndex = 0; fileIndex < files.length; fileIndex += 1) {
          var optimized = await optimizeImageFile(files[fileIndex]);
          formData.append(input.name, optimized, optimized.name || optimizedImageName(files[fileIndex].name));
        }
      }

      return formData;
    }

    async function optimizeImageFile(file) {
      if (!file || !file.type || file.type.indexOf('image/') !== 0) return file;

      if (typeof document === 'undefined' || typeof URL === 'undefined') return file;

      var image = await loadImage(file);
      var originalWidth = image.naturalWidth || image.width;
      var originalHeight = image.naturalHeight || image.height;

      if (!originalWidth || !originalHeight) {
        if (file.size <= IMAGE_UPLOAD_MAX_BYTES) return file;
        throw new Error('Deze afbeelding kon niet automatisch worden verkleind. Gebruik JPG, PNG of WEBP.');
      }

      var scale = Math.min(1, IMAGE_UPLOAD_MAX_EDGE / Math.max(originalWidth, originalHeight));

      if (file.size <= IMAGE_UPLOAD_MAX_BYTES && scale === 1) {
        return file;
      }

      var targetWidth = Math.max(1, Math.round(originalWidth * scale));
      var targetHeight = Math.max(1, Math.round(originalHeight * scale));
      var quality = IMAGE_UPLOAD_QUALITY;
      var optimized = null;

      while (true) {
        optimized = await canvasImageFile(image, targetWidth, targetHeight, quality, file.name);

        if (optimized.size <= IMAGE_UPLOAD_MAX_BYTES) {
          return optimized;
        }

        if (quality > IMAGE_UPLOAD_MIN_QUALITY) {
          quality = Math.max(IMAGE_UPLOAD_MIN_QUALITY, quality - 0.08);
          continue;
        }

        if (Math.max(targetWidth, targetHeight) <= IMAGE_UPLOAD_MIN_EDGE) {
          return optimized;
        }

        targetWidth = Math.max(1, Math.round(targetWidth * 0.86));
        targetHeight = Math.max(1, Math.round(targetHeight * 0.86));
        quality = IMAGE_UPLOAD_QUALITY;
      }
    }

    function loadImage(file) {
      return new Promise(function (resolve, reject) {
        var image = new Image();
        var url = URL.createObjectURL(file);

        image.onload = function () {
          URL.revokeObjectURL(url);
          resolve(image);
        };
        image.onerror = function () {
          URL.revokeObjectURL(url);
          reject(new Error('Deze afbeelding kon niet worden gelezen. Gebruik JPG, PNG of WEBP.'));
        };
        image.src = url;
      });
    }

    function canvasImageFile(image, width, height, quality, originalName) {
      return new Promise(function (resolve, reject) {
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');

        if (!context || !canvas.toBlob) {
          reject(new Error('Je browser kan deze foto niet automatisch verkleinen.'));
          return;
        }

        canvas.width = width;
        canvas.height = height;
        context.fillStyle = '#ffffff';
        context.fillRect(0, 0, width, height);
        context.drawImage(image, 0, 0, width, height);

        canvas.toBlob(function (blob) {
          if (!blob) {
            reject(new Error('Deze foto kon niet worden verkleind.'));
            return;
          }

          var filename = optimizedImageName(originalName);

          try {
            resolve(new File([blob], filename, { type: OPTIMIZED_IMAGE_TYPE, lastModified: Date.now() }));
          } catch (error) {
            blob.name = filename;
            blob.lastModified = Date.now();
            resolve(blob);
          }
        }, OPTIMIZED_IMAGE_TYPE, quality);
      });
    }

    function optimizedImageName(name) {
      var base = String(name || 'hs-garage-foto').replace(/\.[^.]+$/, '');
      return base + '-web.jpg';
    }

    async function submitForm(form, action, options) {
      var response = await fetch(action || form.action, {
        method: form.method || 'POST',
        body: options && options.formData ? options.formData : new FormData(form),
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
        },
      });

      var payload = await readJson(response);

      if (!response.ok || payload.ok === false) {
        throw new Error(payload.error || 'Er ging iets mis.');
      }

      return payload;
    }

    function selectedVehicle() {
      return findVehicle(state.selectedId);
    }

    function findVehicle(id) {
      return state.vehicles.find(function (vehicle) {
        return vehicle.id === id;
      });
    }

    function vehicleTitleText(vehicle) {
      return vehicle.title || [vehicle.brand, vehicle.model, vehicle.variant].filter(Boolean).join(' ') || 'Jouw auto';
    }

    function statusText(vehicle) {
      if (vehicle.moderationStatus === 'pending_review') return 'In beoordeling';
      if (vehicle.moderationStatus === 'published' && vehicle.privacyStatus === 'public') return 'Openbaar';
      if (vehicle.moderationStatus === 'rejected') return 'Afgewezen';
      return 'Prive';
    }

    function statusClassName(vehicle) {
      if (vehicle.moderationStatus === 'pending_review') return 'hs-garage-chip--pending';
      if (vehicle.moderationStatus === 'published' && vehicle.privacyStatus === 'public') return 'hs-garage-chip--public';
      if (vehicle.moderationStatus === 'rejected') return 'hs-garage-chip--rejected';
      return 'hs-garage-chip--private';
    }

    function buildCompleteness(vehicle) {
      var photos = vehicle.photos || [];
      var modifications = vehicle.modifications || [];
      var socialLinks = [vehicle.instagramUrl, vehicle.facebookUrl, vehicle.tiktokUrl].filter(hasValue);
      var steps = [
        { done: hasValue(vehicle.brand) && hasValue(vehicle.model) && hasValue(vehicle.year), hint: 'vul merk, model en bouwjaar aan' },
        { done: hasValue(vehicle.variant) && hasValue(vehicle.engine) && hasValue(vehicle.stage), hint: 'vul uitvoering, motor en stage aan' },
        { done: hasValue(vehicle.powerHp) && hasValue(vehicle.torqueNm), hint: 'voeg vermogen en koppel toe' },
        { done: hasValue(vehicle.color) && hasValue(vehicle.country), hint: 'vul kleur en land/regio aan' },
        { done: hasValue(vehicle.description) && String(vehicle.description).trim().length >= 80, hint: 'schrijf iets uitgebreider over je auto' },
        { done: hasValue(vehicle.mainImage) || photos.length > 0, hint: 'upload minimaal een foto' },
        { done: photos.length >= 3, hint: "upload meer foto's van je auto" },
        { done: modifications.length > 0, hint: 'voeg je mods of onderdelen toe' },
        { done: hasValue(vehicle.ownerProfileImage) || socialLinks.length > 0, hint: 'voeg een profielfoto of social link toe' },
        { done: vehicle.privacyStatus === 'public' && vehicle.moderationStatus === 'published', hint: 'zet je garage online wanneer hij klaar is' },
      ];
      var completed = steps.filter(function (step) {
        return step.done;
      }).length;
      var percent = Math.round((completed / steps.length) * 100);
      var nextStep = steps.find(function (step) {
        return !step.done;
      });

      return {
        percent: percent,
        hint: nextStep ? 'Volgende stap: ' + nextStep.hint + '.' : 'Je garage is compleet ingevuld. Lekker bezig.',
      };
    }

    function hasValue(value) {
      return value !== undefined && value !== null && String(value).trim() !== '';
    }

    function label(value) {
      return STATUS_LABELS[value] || value || '';
    }

    function showMessage(text, type, options) {
      if (!message) return;
      message.textContent = text;
      message.dataset.type = type || 'info';
      message.hidden = false;

      if (options && options.scroll) {
        scrollToElement(message);
      }
    }

    function scrollToVehicleForm() {
      scrollToElement(vehicleFormPanel || vehicleForm);
    }

    function scrollToElement(element) {
      if (!element) return;

      window.setTimeout(function () {
        var headerOffset = 96;
        var top = element.getBoundingClientRect().top + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: Math.max(top, 0),
          behavior: prefersReducedMotion() ? 'auto' : 'smooth',
        });
      }, 40);
    }

    function prefersReducedMotion() {
      try {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (error) {
        return false;
      }
    }

    function setLoading(form, isLoading) {
      if (!form) return;
      form.classList.toggle('is-loading', isLoading);
      Array.prototype.slice.call(form.querySelectorAll('button')).forEach(function (button) {
        if (!button.dataset.keepEnabled) {
          button.disabled = isLoading;
        }
      });
      if (!isLoading) updateActionButtons(selectedVehicle());
    }

    function updateModelOptions() {
      if (!brandSelect || !modelSelect) return;

      var brand = brandSelect.value;
      var currentOption = modelSelect.options[modelSelect.selectedIndex];

      Array.prototype.slice.call(modelSelect.options).forEach(function (option) {
        if (option.value === '') {
          option.hidden = false;
          option.disabled = true;
          return;
        }

        var optionBrand = option.dataset.brand;
        var shouldShow = !optionBrand || optionBrand === brand;
        option.hidden = !shouldShow;
        option.disabled = !shouldShow || !brand;
      });

      if (!brand || (currentOption && currentOption.dataset.brand && currentOption.dataset.brand !== brand)) {
        modelSelect.value = '';
      }
    }

    async function readJson(response) {
      var contentType = response.headers.get('content-type') || '';
      var text = await response.text();

      try {
        return text ? JSON.parse(text) : {};
      } catch (error) {
        var looksLikeHtml = /^\s*</.test(text || '');
        if (response.status === 503 || looksLikeHtml) {
          throw new Error('H&S Garage wordt geladen. Vernieuw de pagina over een paar seconden als je garage nog niet zichtbaar is.');
        }

        if (contentType.indexOf('application/json') === -1) {
          throw new Error('H&S Garage kon geen geldige serverreactie lezen. Vernieuw de pagina en probeer opnieuw.');
        }

        throw new Error('H&S Garage kon geen geldige serverreactie lezen. Vernieuw de pagina en probeer opnieuw.');
      }
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function safeLinkUrl(value) {
      var url = String(value || '').trim();
      if (!url) return '';
      if (url.charAt(0) === '/') return url;
      if (/^https?:\/\//i.test(url)) return url;
      return '';
    }
  });
})();
